/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom'

import SignedInLayout from 'ui/layouts/signedIn'

import Login from 'ui/views/Login'
import PasswordChange from 'ui/views/PasswordChange'
import PasswordConfirmRecover from 'ui/views/PasswordConfirmRecover'
import PasswordRecover from 'ui/views/PasswordRecover'

import Home from 'ui/views/Home'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'

import PeopleMonitoringPage from 'ui/views/PeopleMonitoringPage'
import PeopleDatabase from 'ui/components/PeopleDatabase'
import SecuredRoute from './securedRoute'

const withLoginRoutes = () => (
  <Switch>
    <Route path="/login" exact component={Login} />
    <Route path="/password-change" exact component={PasswordChange} />
    <Route path="/password-confirm-recover" exact component={PasswordConfirmRecover} />
    <Route path="/password-recover" exact component={PasswordRecover} />

    <SecuredRoute
      path={ROUTE_CONSTANTS.PEOPLE_MONITORING}
      parent={SignedInLayout}
      exact
      component={PeopleMonitoringPage}
    />

    <SecuredRoute
      path={ROUTE_CONSTANTS.PEOPLE_MONITORING_REQUEST}
      parent={SignedInLayout}
      exact
      component={PeopleMonitoringPage}
    />

    <SecuredRoute
      path={ROUTE_CONSTANTS.PEOPLE_DATABASE}
      parent={SignedInLayout}
      exact
      component={PeopleDatabase}
    />
    <SecuredRoute
      path={ROUTE_CONSTANTS.PEOPLE_DATABASE_PERSON}
      parent={SignedInLayout}
      exact
      component={PeopleDatabase}
    />
    <SecuredRoute
      path={ROUTE_CONSTANTS.HOME}
      exact
      parent={SignedInLayout}
      child={Home}
    />

    <Route component={Login} />
  </Switch>
)

const withoutLoginRoutes = () => (
  <Switch>
    <Route
      path={ROUTE_CONSTANTS.HOME}
      exact
      component={(rest) => <SignedInLayout component={Home} {...rest} />}
    />

    <Route
      path={ROUTE_CONSTANTS.PEOPLE_MONITORING}
      exact
      component={(rest) => <SignedInLayout component={PeopleMonitoringPage} {...rest} />}
    />
    <Route
      path={ROUTE_CONSTANTS.PEOPLE_MONITORING_REQUEST}
      exact
      component={(rest) => <SignedInLayout component={PeopleMonitoringPage} {...rest} />}
    />
    <Route
      path={ROUTE_CONSTANTS.PEOPLE_DATABASE}
      exact
      component={(rest) => <SignedInLayout component={PeopleDatabase} {...rest} />}
    />
    <Route
      path={ROUTE_CONSTANTS.PEOPLE_DATABASE_PERSON}
      exact
      component={(rest) => <SignedInLayout component={PeopleDatabase} {...rest} />}
    />
    <Route
      render={() => <Redirect to={ROUTE_CONSTANTS.HOME} />}
    />
  </Switch>
)

export default () => {
  return (
    <BrowserRouter>
      {
        process.env.REACT_APP_LOGIN_DISABLED === 'true'
        ? withoutLoginRoutes()
        : withLoginRoutes()
      }
    </BrowserRouter>
  )
}
